





















import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import Question from '@/competences/entities/question'

@Component
export default class QuestionForm extends Vue {
  @Prop()
  private value!: Question

  private model = this.value

  @Watch('value')
  private valueUpdated(val: Question, old: Question) {
    this.model = val
  }
}
